{
  "frozen-columns-onboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Sort, freeze and resize Work from a single control."
    }
  ],
  "frozen-columns-onboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "frozen-columns-onboarding.spotlight.heading": [
    {
      "type": 0,
      "value": "Manage Work"
    }
  ],
  "jira-nin-group-by-any-field-changeboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Group work by fields including versions, labels, work types and more."
    }
  ],
  "jira-nin-group-by-any-field-changeboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-nin-group-by-any-field-changeboarding.spotlight.heading": [
    {
      "type": 0,
      "value": "Group work to stay organized"
    }
  ]
}